<template>
  <div>
    <div class="flex justify-center">
      <ButtonContentSection
        v-if="buttonText === null"
        :label="$t('article.cs.play.audio.semantics')"
        :icon="PlayIcon"
        @click="openModal = true"
      />
      <ButtonContentSection
        v-else
        :label="buttonText"
        :icon="PlayIcon"
        @click="openModal = true"
      />
    </div>
  </div>
  <TransitionRoot as="template" :show="openModal">
    <Dialog as="div" class="relative z-50" @close="openModal = false">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        />
      </TransitionChild>

      <div class="fixed z-10 inset-0 overflow-y-auto">
        <div
          class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0"
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="flex relative overflow-hidden transform transition-all sm:my-8 sm:max-w-sm sm:w-full sm:p-6"
            >
              <audio
                :key="audio"
                controls
                class="shadow-xl rounded-3xl sm:w-full"
              >
                <source :src="audio" />
              </audio>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import ButtonContentSection from "../layout/button/ButtonContentSection.vue";
import PlayIcon from "../icon/PlayIcon.vue";

export default {
  name: "AudioModal",
  components: {
    ButtonContentSection,
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
  },
  props: {
    thumbnail: String,
    buttonText: String,
    audio: String,
  },
  data() {
    return {
      openModal: false,
    };
  },
  computed: {
    PlayIcon() {
      return PlayIcon;
    },
  },
};
</script>
